<template>
  <div id="app" :class="{'hide-menu': !isMenuVisible || !user}">
    <Header v-if="user" title="e-SIG" :hideToggle="!user" :hideUserDropdown="!user" />
    <Menu v-if="user" />
    <Loading v-if="validatingToken" />
    <Content v-else />
    <Footer v-if="user" />
    <div v-else class="ambienteAtual"><span>{{ ambienteAtual }}</span></div>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, userKey } from "@/global";
import { mapState } from "vuex";
import Header from "@/components/layout/Header";
import Menu from "@/components/layout/Menu";
import Content from "@/components/layout/Content";
import Footer from "@/components/layout/Footer";
import Loading from "@/components/layout/Loading";
import ambiente from './ambiente.json'
export default {
  name: "App",
  components: { Header, Menu, Content, Footer, Loading },
  computed: mapState(["isMenuVisible", "user"]),
  data: function() {
    return {
      validatingToken: true,
      ambienteAtual: ''
    };
  },
  methods: {
    getHome(){
      
    },
    async validateToken() {
      this.validatingToken = true;
      const json = localStorage.getItem(userKey);
      let userData = JSON.parse(json);
      if(!this.$store.state.user)
        this.$router.push({ name: "login" }).catch(() => {});

      // se a rota for login ou recovery, limpa state e remove token
      if(this.$route.name == 'login' || this.$route.name == 'recovery'){
        this.$store.commit("setUser", null)
        localStorage.removeItem(userKey);

        this.validatingToken = false;
        return;
      }
      
      //se nao existir o token e nao for a rota login
      if (!userData) {
        console.log("NOT USERDATA")
        this.$store.commit("setUser", null);
        this.validatingToken = false;
        if (this.$route.name !== "login") 
          this.$router.push({ name: "login" }).catch(() => {});
        return;
      }

      //corrige o header (para f5 na pagina)
      axios.defaults.headers.common['Authorization'] = `Bearer ${userData.access_token}`
      /*
      let resp = {}
      try{
        resp = await axios.post(`${baseApiUrl}/refresh-token`)
      }
      catch(e){
          console.log("errortrycatch", e)
      }

      if(resp.data){
        this.$store.commit("setUser", resp.data)
        localStorage.setItem(userKey, JSON.stringify(resp.data));
        if (this.$mq === "xs" || this.$mq === "sm") {
          this.$store.commit("toggleMenu", false)
        }
      }else{
        localStorage.removeItem(userKey);
        this.$store.commit("setUser", null)
        this.$router.push({ name: "login" }).catch(() => {});
      }
      */

      if(userData == null)
        userData = {};
      if(userData.access_token == null)
        userData.access_token = "";

      axios.post(`${baseApiUrl}/refresh-token`, userData.access_token).then( 
        (resp) => {
          this.validatingToken = false;
          if(resp.data){
            this.$store.commit("setUser", resp.data)
            localStorage.setItem(userKey, JSON.stringify(resp.data));
            if (this.$mq === "xs" || this.$mq === "sm") {
              this.$store.commit("toggleMenu", false)
            }
          }else{
            localStorage.removeItem(userKey);
            this.$store.commit("setUser", null)
            this.$router.push({ name: "login" }).catch(() => {});
          }

        }
      )
      .catch( (err) => {
        this.validatingToken = false;
        console.log(err)
      })
      
    }
  },
  created() {
    this.validateToken();
  },
  mounted(){
    this.ambienteAtual = ambiente.ambiente;
  }
};
</script>

<style>
* {
  font-family: "Open Sans", sans-serif;
}

body {
  margin: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  height: 100vh;
  display: grid;
  grid-template-rows: 57px 1fr 50px;
  grid-template-columns: 240px 1fr;
  grid-template-areas:
    "menu header"
    "menu content"
    "menu footer";
}

#app.hide-menu {
  grid-template-areas:
    "header header"
    "content content"
    "footer footer";
}


.ambienteAtual{
  grid-area: footer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ambienteAtual span{
  grid-area: footer;
  color: #fff;
  padding: 10px 30px 10px 30px;
  background-color: red;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}


</style>